(() => {
    const bootstrap = require('bootstrap');
    const $inputField = $('#inspirations-input');
    const $form = $('#add-inspirations-form');
    const deleteModalElement = document.getElementById('delete-item-modal');
    const deleteModal = deleteModalElement ? new bootstrap.Modal(deleteModalElement) : null;

    $form.on('change', '#inspirations-input', (e) => {
        let files = e.target.files;
        let startingIndex = $form.find('.inspiration-form-element').length;
        Array.from(files).forEach((file, index) => {
            let template = $('#inspiration-preview').html();
            template = template.replaceAll('{%index%}', index + startingIndex);
            let formData = new FormData();
            formData.append('file', file);
            $.ajax({
                url: '/api/inspirations/create',
                type: 'post',
                data: formData,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                contentType: false,
                processData: false,

            })
                .done(function (data) {
                    if (data.status === 200) {
                        template = template.replaceAll('{%id%}', data.data.id);
                        var reader = new FileReader();

                        if (data.data.error === true) {
                            template = template.replaceAll('{%display%}', '');
                        } else {
                            template = template.replaceAll('{%display%}', 'display: none;');
                        }
                        reader.onload = function (e) {
                            template = template.replace('{%src%}', e.target.result);
                            $(template).insertBefore('#inspiration-form-submit-button');
                        }
                        reader.readAsDataURL(file); // convert to base64 string
                    }
                });


        })
    });

    $form.on('click', 'button.remove-inspiration-element', (e) => {
        e.preventDefault();
        let $parent = $(e.target).closest('.inspiration-form-element');
        let inspId = $parent.find('input[type=hidden]').val();
        $form.append(`<input type="hidden" name="delete[]" value="${inspId}">`);
        $parent.remove();
    });

    $(document).on('click', 'a.inspiration-removal', (e) => {
        e.preventDefault();
        deleteModal?.show();
        let elementAction = $(e.target).attr('href');
        $(deleteModalElement).on('click', 'button[type=submit]', (event) => {
            window.location.href = elementAction;
        })
    })

    $(document).on('click', 'button.project-removal', (e) => {
        e.preventDefault()
        deleteModal?.show();
        let elementAction = $(e.target);
        $(deleteModalElement).on('click', 'button[type=submit]', (event) => {
            elementAction.next('form').submit();
        })
    });
})();
